import Input from "../../../../../shared/components/UI/Input";
import { FieldErrors, UseFormRegister } from "react-hook-form";

interface Props {
  placeholder: string;
  isVisible: boolean;
  toggle: () => void;
  inputName: string;
  register: UseFormRegister<any>;
  errors: FieldErrors;
}

export default function PasswordInput({
  placeholder,
  isVisible,
  toggle,
  inputName,
  register,
  errors,
}: Props) {
  const hasError = !!errors[inputName];
  return (
    <div className="cabinet_profileeditmodal-right-content-password">
      <div className="cabinet_profileeditmodal-right-content-password-wrapper">
        <Input
          type={isVisible ? "text" : "password"}
          grayStyle
          placeholder={placeholder}
          className={`cabinet_profileeditmodal-right-content-password-wrapper-input ${
            hasError ? "input-error" : ""
          }`}
          {...register(inputName)}
        />
        <img
          onClick={(e) => {
            e.preventDefault();
            toggle();
          }}
          src={`${process.env.PUBLIC_URL}/modal/${
            isVisible ? "visible" : "hidden"
          }Password.svg`}
          alt=""
          className="cabinet_profileeditmodal-right-content-password-wrapper-image"
          style={{ cursor: "pointer" }}
        />
      </div>
    </div>
  );
}
